import dayjs from 'dayjs';
import { IScheduling } from 'app/shared/model/scheduling.model';

export interface ISchedulingHistory {
  id?: number;
  created?: string | null;
  scheduling?: IScheduling | null;
}

export const defaultValue: Readonly<ISchedulingHistory> = {};
